// extracted by css-extract-rspack-plugin
export default {"cls1":"ButtonsPage-cls1_HDm","cls2":"ButtonsPage-cls2_yUe ButtonsPage-cls1_HDm"};